import { createContext } from 'react';

export const PlansAndPricingContext = createContext();
